import React from 'react'
import { createRoot } from 'react-dom/client'
import { pageLanguage, siteUrls } from '../components/Data'
import { TeachingConfig } from '../components/TeachingPage/Config'

// <teaching-overview lang>: the semesters and their courses as Moodle has them (static/courses*.json),
// with the views "#semester" and "#semester:course". Its menu goes into the side column of the page if
// there is one (.teaching-sidebar), and it names the semester and course in the breadcrumb.
export class TeachingOverviewElement extends HTMLElement {
  connectedCallback () {
    const lang = this.getAttribute('lang') ?? pageLanguage();
    const sidecolumn = document.querySelector('.teaching-sidebar') as HTMLElement | null;
    const breadcrumb = document.querySelector('.site-breadcrumb li.active') as HTMLElement | null;
    if (sidecolumn) sidecolumn.innerHTML = '';
    if (breadcrumb) breadcrumb.innerHTML = '';
    const mountPoint = document.createElement('div')
    this.appendChild(mountPoint)
    createRoot(mountPoint).render(<TeachingConfig lang={lang} urls={siteUrls(lang)} sidecolumn={sidecolumn} breadcrumb={breadcrumb} />)
  }
}
customElements.define('teaching-overview', TeachingOverviewElement)
